// import { get_Token } from "util/Helper";
import axiosInstance from "../../../../axios";

// Get SubAdmin
export const getSubAdminUserService = async (payload) => {
  try {
    const response = await axiosInstance.get(`/auth/subadmin`, {
      params: payload,
    });
    console.log(response, "ohio");
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Get SubAdmin by ID
export const getSubAdminUserbyIdService = async (id) => {
  try {
    const response = await axiosInstance.get(`/auth/subadmin/${id}`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Get SubAdmin Modules
export const getModules = async (id) => {
  try {
    const response = await axiosInstance.get(`/module`);

    if (response?.status === 200) {
      return response?.data;
    }
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Add SubAdmin
export const addSubAdminUserService = async (payload) => {
  try {
    const response = await axiosInstance.post(`/auth/subadmin`, payload);
    return { data: response };
  } catch (e) {
    console.log(e, "AAAAAAA")
    return { error: e?.response?.data };
  }
};

// Update SubAdmin
export const updateSubAdminUserService = async (payload, id) => {
  try {
    const response = await axiosInstance.patch(`/auth/subadmin/${id}`, payload);
    console.log("RESPONSE AFTER ACTION", response);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Delete SubAdmin
export const deleteSubAdminUserService = async (id) => {
  try {
    const response = await axiosInstance.delete(`/auth/subadmin/${id}`);
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};

// Activate SubAdmin
export const activateSubAdminUserService = async (id) => {
  try {
    const response = await axiosInstance.get(`/auth/subadmin/change-status/${id}`);
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};

// Deactivate SubAdmin
export const deactivateSubAdminUserService = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/auth/subadmin/change-status/${id}`
    );
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};

// Send SubAdmin account creds
export const SendLoginCredsSubAdminUserService = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/auth/send-account-creds`,
      payload
    );
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};

// Get Level
export const GetLevelService = async (payload) => {
  try {
    const response = await axiosInstance.get(`/level`, payload);
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};

//Update Level
export const updateLevelService = async (payload) => {
  try {
    const response = await axiosInstance.patch(`/level`, payload);
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};
